<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="centerfull">
<img alt="" src="image/graykeys1.gif"/>
</div>
<p class="main-text_section-head" id="_idParaDest-2">This Is Not the Beginning</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x9781541541771-3.vue?19763836